import {FireBaseRegister} from './notifications.model'
import axios, {AxiosResponse} from 'axios'
import {DeviceGroup} from '@/app/pages/nguoidung/nguoidung-list/core/_modelsDeviceGroup'
import {DynamicConfig} from '@/configuration/config'
import {boolean} from 'yup'

export const PREFIX_FB = '/Firebase'

// const firebaseRegisterFCMToken = (payload: FireBaseRegister) => {
//   return httpClient.post(`${PREFIX_FACT}/fb-register`, payload);
// };

// const firebaseUnregisterFCMToken = (token: string) => {
//   return httpClient.post(`${PREFIX_FACT}/fb-unregister`, { Token: token });
// };

const firebaseRegisterFCMToken = (
  configs: DynamicConfig,
  id: string
): Promise<DeviceGroup | undefined> => {
  return axios
    .post(`${configs.adapterUrl}${PREFIX_FB}/fb-register`, {Token: id})
    .then((d: AxiosResponse<DeviceGroup>) => d.data)
}

const firebaseUnregisterFCMToken = (
  configs: DynamicConfig,
  id: string
): Promise<DeviceGroup | undefined> => {
  return axios
    .post(`${configs.adapterUrl}${PREFIX_FB}/fb-unregister`, {Token: id})
    .then((d: AxiosResponse<DeviceGroup>) => d.data)
}

const confirmNotification = (
  configs: DynamicConfig,
  data: any
): Promise<DeviceGroup | undefined> => {
  return axios
    .post(`${configs.apiUrl}/DeviceInfo/trigger-event-from-camera`, {
      Imei: data.Imei,
      EventId: +data.EventId,
      Active: Boolean(data.Active),
    })
    .then((d: AxiosResponse<DeviceGroup>) => d.data)
}

// const getNewStringeeToken = () => httpClient.get<string>(`${PREFIX_FACT}/refresh-token-click-to-call`);

const NotificationService = {
  firebaseRegisterFCMToken,
  firebaseUnregisterFCMToken,
  confirmNotification,
  // getNewStringeeToken,
}

export default NotificationService
